import React from 'react';

import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { formStyles } from 'consts/styles/Form';

const useStyles = makeStyles(() => ({
  Container: {
    position: 'absolute',
    bottom: 20,
  },
}));

const DashboardPagination = props => {
  const { paginationCounter, paginationNumber, setPaginationNumber } = props;

  const classes = useStyles();
  const formClasses = formStyles();

  return (
    <Pagination
      key="pagination"
      boundaryCount={2}
      className={`${classes.Container}`}
      count={paginationCounter}
      defaultPage={1}
      value={paginationNumber}
      page={paginationNumber}
      onChange={(e, page) => {
        setPaginationNumber(page);
      }}
      renderItem={item => (
        <PaginationItem
          classes={{
            root: `${formClasses.Form}__text-field`,
            selected: `${formClasses.Form}__text-field--black ${formClasses.Form}__tabs__button`,
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...item}
        />
      )}
    />
  );
};

DashboardPagination.propTypes = {
  paginationCounter: PropTypes.number.isRequired,
  paginationNumber: PropTypes.number,
  setPaginationNumber: PropTypes.func,
};

export default DashboardPagination;
